// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { CriteriaFilterBase, CriteriaFilterBaseSchema } from 'api/gen/CriteriaFilterBase';

const requiredPart = t.interface({
  tag: t.literal('INT'),
  leftValue: t.union([t.Integer, t.null]),
  rightValue: t.union([t.Integer, t.null]),
});

export const CriteriaIntegerFilterSchema = excess(t.intersection([CriteriaFilterBaseSchema.type, requiredPart]));

export interface CriteriaIntegerFilter extends t.TypeOf<typeof CriteriaIntegerFilterSchema> {}
